import React from 'react'
import cellRenderer from './InlineEditingCellRenderer.js'
const ReactDataGrid = require('react-data-grid')
const { Row } = ReactDataGrid

const inlineEditingRowRenderer = props => {
  //console.log('[inlineEditingRowRenderer.js]', props)
  return (
    <Row
      {...props}
      cellRenderer={cellRenderer}
    />
  )
}

export default inlineEditingRowRenderer
